<!-- Image -->
@if (initialRender()) {
  <img
    [ngSrc]="listing().primaryImage"
    [alt]="listing().vls"
    width="496"
    height="300"
    class="w-full aspect-video object-cover max-h-80"
    placeholder
    [priority]="true"
  />
} @else {
  <img
    [ngSrc]="listing().primaryImage"
    [alt]="listing().vls"
    width="496"
    height="300"
    class="w-full aspect-video object-cover max-h-80"
    placeholder
  />
}

<!-- Details -->
<div class="grid grid-cols-[1fr_auto] px-2 py-3">
  <div class="flex flex-col gap-0.5 text-sm leading-tight">
    <!-- Address -->
    <p class="truncate" [title]="listing().address.streetAddress">
      {{ listing().address.streetAddress }}
    </p>

    <!-- Village -->
    @if (stateService.community() === 'villages') {
      <p class="truncate" [title]="listing().village.displayTitle ?? ''">
        {{ listing().village.displayTitle ?? listing().village.displayTitle }}
      </p>
    }

    <!-- Will Accomodate -->
    @if (willAccommodateColors().length > 0) {
      <div class="flex gap-1">
        @for (color of willAccommodateColors(); track $index) {
          <p class="flex items-center gap-1">
            <span class="inline-block w-3 h-3 rounded-full" [style.background]="color"></span>
          </p>
        }
      </div>
    }
  </div>

  <div class="flex flex-col-reverse items-end justify-between shrink-0">
    <app-save-listing [listing]="listing()" />

    @if (!listing().pending) {
      <p
        class="font-header text-lg sm:text-2xl leading-none text-primary-500 dark:text-white/70 whitespace-nowrap"
      >
        {{ listing().price | currency: 'USD' : 'symbol' : '1.0-0' }}
      </p>
    }
  </div>
</div>
